import { formatDate, formatDateOnly, whenText as sharedWhenText, type DateFormat } from '@bms2/shared';
import { useDateFormat, useViewerZone } from './ViewerZone';

/**
 * An ISO instant as the reader's short date and time in their own zone with the
 * zone named after it, 09/12/2026 5:00 PM EST, or the raw text when it is not
 * one. 🔨 Never the stored UTC clock (product owner, 2026-09-12). The one
 * `whenText` in the web app (T664) now lives in `@bms2/shared` beside the date
 * formatter, so the phone reads the same function (T2428). 🔨 The format is never
 * defaulted here, as no formatter defaults it (T531, T3482): a caller names it.
 */
export function whenText(at: string | null | undefined, zone: string, format: DateFormat): string {
  return sharedWhenText(at, zone, format);
}

/**
 * The day an instant falls on, as the viewer reads it (T663): in the viewer's zone and in the
 * Settings date format, so one moment near midnight shows one date on every screen. A date column
 * (midnight UTC) reads as that date. An empty value reads as nothing. 🔨 A value that must stay an
 * ISO day, a date picker's value or a comparison key, keeps `calendarDayInZone` and says so.
 */
export function useDayText(): (instant: string | null | undefined) => string {
  const zone = useViewerZone();
  const format = useDateFormat();
  return (instant) => {
    if (!instant) return '';
    return instant.endsWith('T00:00:00.000Z') ? formatDateOnly(instant, format) : formatDate(instant, zone, format);
  };
}
